import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';
import update from 'immutability-helper';

//helpers:
import { getData, postData } from '../../dataLib';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import InputBase from '@material-ui/core/InputBase';


import NeuriteGrid from '../../components/neurite_grid';
import FloatNumberFormatInput from '../../components/float_number_input_formatter';
import IntNumberFormatInput from '../../components/int_number_input_formatter';
//import FloatNumberFormatText from '../../components/float_number_text_formatter';
import IntNumberFormatText from '../../components/int_number_text_formatter';

//actions:
import { openDialog, hideDialog, setSaveState } from '../../actions';


const styles = theme => ({
    title: {
        margin: '5px 10px',
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
    header: {
        display: 'flex'
    },
    headerBox: {
        width: 80,
        margin: 0,
        fontSize: 12,
        fontWeight: 500,
        display: 'flex',
        justifyContent: 'center',
        border: '1px solid #dddddd',
        background: '#f9f9f9',
    },
    table: {
        display: 'inline-block',
        border: '1px solid #dddddd',
    },
    row: {
        display: 'flex',
    },
    rowTextCell: {
        width: 80,
        fontSize: 12,
        textAlign: 'right',
        border: '1px solid #dddddd',
        paddingRight: theme.spacing(1),
        paddingLeft: theme.spacing(1),
    },
    inputCell: {
        textAlign: 'right',
        fontSize: 12,
        padding: 0
    },
    bottomBtn: {
        direction: 'rtl'
    },
    button: {
        margin: '15px 8px',
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    }
});

class EditLecturasContador extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            lecturas: [],
            showSpinner: true,
            update: true,
            modified: []
        }
    }

    shouldComponentUpdate = (nextProps, nextState) => {
        return nextState.update;
    }

    componentDidMount = () => {
        this.getLecturas();
    }

    messageDialog = (msg) => {

        this.props.openDialog('SimpleMessage', {
            message: msg
        }, uuidv4(), false, 'sm');

    };


    getLecturas = () => {

        let lectURL = 'DCLecturas?contador_id=' + this.props.id;

        getData(lectURL,
            (response) => {
                this.setState({ ...this.state, lecturas: response.data, modified: [], showSpinner: false })
            },
            (error) => {
                this.props.openDialog('SimpleMessage', {
                    message: 'error obteniendo lecturas'
                }, 'error-obtener-lecturas-contador', false, 'sm');
            },
            this.props.user
        );
    };


    updateLecturas = () => {

        let error = false;

        // XAC - comentado porque quieren poder poner contadores que empiezan otra vez desde 0 o con otros valores completamente distintos
        // this.state.lecturas.forEach(l => {

        //     if (l.contadorIni > l.contadorFin) {

        //         this.props.openDialog('SimpleMessage', {
        //             message: 'El contador inicial no puede ser mayor al contador final en ninguna de las lecturas'
        //         }, 'error-guardar-lecturas-contador', false, 'sm');

        //         error = true;
        //     }

        // });


        if (!error) {

            let lectURL = 'DCLecturas/lecturas';

            this.setState({ ...this.state, showSpinner: true });

            postData(lectURL,
                () => {
                    this.props.hideDialog();
                    this.props.openDialog('SimpleMessage', {
                        message: 'lecturas actualizadas'
                    }, uuidv4(), false, 'sm');
                    this.props.setSaveState(false);
                },
                () => {
                    this.props.openDialog('SimpleMessage', {
                        message: 'error actualizando lecturas'
                    }, 'error-actualizar-lecturas-contador', false, 'sm');
                },
                this.state.lecturas.filter(l => this.state.modified.includes(l.id)),
                this.props.user
            );

        }

    };


    handleGridRowsUpdated = ({ fromRow, toRow, fromRowData, updated }) => {

        let rows = this.state.lecturas.slice();
        let mod = this.state.modified.slice();

        const i = fromRowData.grid_index;

        console.log(fromRowData);

        let updatedRow = update(this.state.lecturas[i], { $merge: updated });
        rows[i] = updatedRow;

        if (!mod.includes(updatedRow.id)) mod.push(updatedRow.id);

        if (i < rows.length - 1) {
            rows[i + 1] = { ...rows[i + 1], contadorIni: updatedRow.contadorFin, controlContIni: updatedRow.controlContFin };
            if (!mod.includes(rows[i + 1].id)) mod.push(rows[i + 1].id);
        }

        this.setState({ ...this.state, lecturas: rows, modified: mod, update: true });

    };


    handleFieldChange = (event, index, field) => {

        var rows = this.state.lecturas.slice();
        rows[index] = { ...this.state.lecturas[index], [field]: event.target.value };
        if (field === 'contadorFin' && index !== rows.length - 1) rows[index + 1] = { ...this.state.lecturas[index + 1], contadorIni: event.target.value };
        this.setState({ ...this.state, lecturas: rows, update: false });

    }

    handleBlur = (event, index, field) => {

        if (this.state.update === false) this.setState({ ...this.state, update: true });

    }



    renderDataGrid = () => {

        const { classes } = this.props;

        return (
            <div className={classes.table}>
                {this.renderHeaders()}
                {this.state.lecturas.map((row, index) => {
                    return this.renderRow(row, index);
                })}
            </div>
        );
    }

    renderHeaders = () => {

        const { classes } = this.props;

        return (
            <div className={classes.header}>
                <div className={classes.headerBox}>Fecha</div>
                <div className={classes.headerBox}>Cont. Ini</div>
                <div className={classes.headerBox}>Cont. Fin</div>
                <div className={classes.headerBox}>Multipl.</div>
                <div className={classes.headerBox}>Precio</div>
                <div className={classes.headerBox}>Ingresos</div>
                <div className={classes.headerBox}>Fichas</div>
            </div>
        );
    }

    renderRow = (row, index) => {

        const { classes } = this.props;
        return (
            <div className={classes.row} key={index}>
                <div className={classes.rowTextCell}>{row.fecha.slice(0, 10)}</div>
                <div className={classes.rowTextCell}><IntNumberFormatText value={row.contadorIni} /></div>
                <div className={classes.rowTextCell}>
                    <InputBase
                        id={"lectura-contador-fin" + index}
                        value={this.state.lecturas[index].contadorFin}
                        inputComponent={IntNumberFormatInput}
                        classes={{ input: classes.inputCell }}
                        onChange={(event) => this.handleFieldChange(event, index, 'contadorFin')}
                        onBlur={(event) => this.handleBlur(event, index, 'contadorFin')}
                        onKeyPress={(event) => {
                            if (event.key === 'Enter') { event.preventDefault(); this.handleBlur(event, index, 'contadorFin') }

                        }}
                    />
                </div>
                <div className={classes.rowTextCell}>
                    <InputBase
                        id={"lectura-multiplicador-" + index}
                        value={this.state.lecturas[index].multiplicador}
                        inputComponent={FloatNumberFormatInput}
                        classes={{ input: classes.inputCell }}
                        onChange={(event) => this.handleFieldChange(event, index, 'multiplicador')}
                        onBlur={(event) => this.handleBlur(event, index, 'multiplicador')}
                        onKeyPress={(event) => {
                            if (event.key === 'Enter') { event.preventDefault(); this.handleBlur(event, index, 'multiplicador') }
                        }}

                    />
                </div>
                <div className={classes.rowTextCell}>
                    <InputBase
                        id={"lectura-precio-" + index}
                        value={this.state.lecturas[index].precio}
                        inputComponent={FloatNumberFormatInput}
                        classes={{ input: classes.inputCell }}
                        onChange={(event) => this.handleFieldChange(event, index, 'precio')}
                        onBlur={(event) => this.handleBlur(event, index, 'precio')}
                        onKeyPress={(event) => {
                            if (event.key === 'Enter') { event.preventDefault(); this.handleBlur(event, index, 'precio') }

                        }}
                    />
                </div>
                <div className={classes.rowTextCell}>
                    <InputBase
                        id={"lectura-ingresos-" + index}
                        value={this.state.lecturas[index].ingresos}
                        inputComponent={FloatNumberFormatInput}
                        classes={{ input: classes.inputCell }}
                        onChange={(event) => this.handleFieldChange(event, index, 'ingresos')}
                        onBlur={(event) => this.handleBlur(event, index, 'ingresos')}
                        onKeyPress={(event) => {
                            if (event.key === 'Enter') { event.preventDefault(); this.handleBlur(event, index, 'ingresos') }

                        }}
                    />
                </div>
                <div className={classes.rowTextCell}>
                    <InputBase
                        id={"lectura-fichas-" + index}
                        value={this.state.lecturas[index].fichas}
                        inputComponent={IntNumberFormatInput}
                        classes={{ input: classes.inputCell }}
                        onChange={(event) => this.handleFieldChange(event, index, 'fichas')}
                        onBlur={(event) => this.handleBlur(event, index, 'fichas')}
                        onKeyPress={(event) => {
                            if (event.key === 'Enter') { event.preventDefault(); this.handleBlur(event, index, 'fichas') }

                        }}
                    />
                </div>
            </div>
        );

    }

    render() {

        const { classes } = this.props;

        return (
            <div >
                <Typography variant="h6" className={classes.title} color={'primary'}>Lecturas</Typography>

                {/* {!this.props.showSpinner ?

                    this.renderDataGrid()

                    : <div className={classes.spinnerContainer}> <CircularProgress className={classes.spinner} color="primary" /> </div>} */}

                {!this.props.showSpinner ?

                    <NeuriteGrid
                        id="e_l_c"
                        columns={this.props.tipoB ? [
                            { key: 'fecha', name: 'Fecha', editable: false, dragable: false, type: 'date', width: 90 },
                            { key: 'contadorIni', name: 'Cont. Ini.', editable: true, dragable: false, type: 'int', width: 120 },
                            { key: 'contadorFin', name: 'Cont. Fin.', editable: true, dragable: false, type: 'int', width: 120 },
                            { key: 'controlContIni', name: 'Cont. Salidas Ini.', editable: true, dragable: false, type: 'int', width: 120 },
                            { key: 'controlContFin', name: 'Cont. Salidas Fin.', editable: true, dragable: false, type: 'int', width: 120 },
                            { key: 'multiplicador', name: 'Multipl.', editable: true, dragable: false, type: 'float', width: 70 },
                            { key: 'precio', name: 'Precio', editable: true, dragable: false, type: 'float', width: 60 },
                            { key: 'ingresos', name: 'Ingresos', editable: true, dragable: false, type: 'float', width: 80 },
                            { key: 'fichas', name: 'Fichas', editable: true, dragable: false, type: 'float', width: 60 },
                        ]
                            :
                            [
                                { key: 'fecha', name: 'Fecha', editable: false, dragable: false, type: 'date', width: 90 },
                                { key: 'contadorIni', name: 'Cont. Ini.', editable: true, dragable: false, type: 'int', width: 120 },
                                { key: 'contadorFin', name: 'Cont. Fin.', editable: true, dragable: false, type: 'int', width: 120 },
                                { key: 'multiplicador', name: 'Multipl.', editable: true, dragable: false, type: 'float', width: 70 },
                                { key: 'precio', name: 'Precio', editable: true, dragable: false, type: 'float', width: 60 },
                                { key: 'ingresos', name: 'Ingresos', editable: true, dragable: false, type: 'float', width: 80 },
                                { key: 'fichas', name: 'Fichas', editable: true, dragable: false, type: 'float', width: 60 },
                            ]
                        }
                        rows={this.state.lecturas}
                        height={400}
                        buttonEdit={false}
                        buttonDelete={false}
                        enableSelection={false}
                        //onRowsUpdated={({ fromRow, toRow, updated }) => this.handleGridRowsUpdated(toRow, updated)}
                        onRowsUpdated={this.handleGridRowsUpdated}
                    />

                    : <div className={classes.spinnerContainer}> <CircularProgress className={classes.spinner} color="primary" /> </div>}

                <div className={classes.bottomBtn}>
                    <Button variant="contained" color="primary" className={classes.button} onClick={() => { this.updateLecturas() }}>Guardar</Button>
                    <Button variant="contained" color="secondary" className={classes.button} onClick={() => { this.props.hideDialog() }}>Cerrar</Button>
                </div>
            </div>
        );

    };

};

EditLecturasContador.propTypes = {
    //state
    saveState: PropTypes.bool.isRequired,

    //dispatch
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,

    id: PropTypes.number.isRequired

};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        saveState: state.saveState
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openDialog,
        hideDialog,
        setSaveState
    }, dispatch);
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(EditLecturasContador));